import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background-color: ${({ theme }) => theme.neutral_500};
  color: ${({ theme }) => theme.neutral_100};
  font-size: 10rem;

  width: 100vw;
  height: 100vh;
`;

export const Image = styled.img`
  max-width: 480px;
  width: 100%;
`;
